module.exports = __webpack_public_path__ + "media/images/application/template/product-selector/wind-map-two-fa1844e8c3dec197ac4ff2476da2e8bf.jpg";